<template>
    <Primitive
        :as="as"
        :class="classes"
    >
        <slot />
    </Primitive>
</template>

<script setup lang="ts">
import type { KEyebrowProps } from './types'
import useBem from '@yeeroen/use-bem'
import { Primitive } from 'reka-ui'

import { computed } from 'vue'

defineOptions({ name: 'KEyebrow' })

const props = withDefaults(defineProps<KEyebrowProps>(), {
    as: 'span',
    variant: 'text',
})

defineSlots<{
    default?: () => unknown
}>()

const { block, modifier } = useBem('k-eyebrow')

const classes = computed(() => block(
    modifier(props.variant),
))
</script>

<style lang="scss">
@use './k-eyebrow.scss';
</style>
